import { types, Instance } from 'mobx-state-tree';
const { model, string, identifier, maybe } = types;

export const UserModel = model('UserModel', {
  dn: identifier,
  uid: maybe(string),
  sn: string,
  givenname: maybe(string),
  mail: maybe(string),
});

export type IUserModel = Instance<typeof UserModel>;
